export default __webpack_public_path__ + "static/media/base-report21.f8402ae8.png";